<template>
  <div style="min-width: 1100px">
    <Tabs :value="appName" @on-click="tabChanged">
      <TabPane label="我能帮帮忙" name="I_Can_Help">
        <Card class="mainBody">
          <div class="leftPanel">
            <div class="phoneTitle"><p style="color:white;font-size: 16px;">{{publicTitle}}</p></div>
            <draggable class="list-group" tag="ul" v-model="menuList" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
                <li class="list-group-item" :class="menuSize" v-for="(item, index) in menuList" :key="item.name">
                  <a href="javascript:void(0)" class="pre_menu_link" @click="selectMenu(item, index)" v-show="!editable">
                    <span class="badge">{{item.name}}</span>
                  </a>
                  <a href="javascript:void(0)" class="pre_menu_link" v-show="editable">
                    <span class="badge">{{item.name}}</span>
                  </a>
                  <div class="sub_pre_menu" v-if="selectedMenu.name === item.name" v-show="!editable">
                    <ul class="sub_pre_menu_list" v-if="item['sub_button']">
                      <li class="sub-group-item"  v-for="(element, index2) in item.sub_button" :key="element.name">
                        <a href="javascript:void(0)" class="pre_menu_link" @click="selectSubMenu(element, index, index2)">
                          <span class="badge">{{element.name}}</span>
                        </a>
                      </li>
                      <li class="add_list" v-if="item['sub_button'].length !== 5">
                        <a href="javascript:void(0)" class="add_link" title="最多添加5个二级菜单" draggable="false" @click="addSubMenu(index)">
                          <i class="add_icon"></i>
                        </a>
                      </li>
                    </ul>
                    <ul class="sub_pre_menu_list" v-else>
                      <li class="add_list">
                        <a href="javascript:void(0)" class="add_link" title="最多添加5个二级菜单" draggable="false" @click="addSubMenu(index)">
                          <i class="add_icon"></i>
                        </a>
                      </li>
                    </ul>
                    <i class="arrow_out"></i>
                    <i class="arrow_in"></i>
                  </div>
                </li>
                <li class="add_list" :class="menuSize" v-if="menuList.length !== 3" v-show="!editable">
                  <a href="javascript:void(0)" class="add_link" title="最多添加3个一级菜单" draggable="false" @click="addMenu">
                    <i class="add_icon"></i>
                  </a>
                </li>
            </draggable>
            <div style="width: 100%;text-align: center;position: relative; top: 520px">
              <Button type="default" ghost class="orderBtn" v-if="!editable" @click="startDrag">菜单排序</Button>
              <Button type="default" ghost @click="finishDrag" class="orderBtn" v-if="editable">完成</Button>
            </div>
          </div>
          <div class="rightPanel">
            <div class="message" v-show="messageShow.show">{{messageShow.tip}}</div>
            <div class="edit_area" v-show="!messageShow.show">
              <div class="edit_area_header">
                <div style="height: 20px">
                  <h3 style="float: left">{{editAreaShow.title}}名称</h3>
                  <a href="javascript:void(0);" style="float: right;" @click="deletePublicMenu">删除{{editAreaShow.title}}</a>
                </div>
              </div>
              <div class="edit_area_name">
                <div v-show="!editAreaShow.show">
                  <p class="small-title">已添加子菜单，仅可设置菜单名称。</p><br>
                </div>
                <label style="font-size: 16px; margin-right: 16px">{{editAreaShow.title}}名称</label>
                <div style="display: inline-grid;">
                  <Input style="width: 350px;" v-model="selectedBtn.name" @on-change="disInRealtime(1)"></Input>
                  <p style="font: 12px gray; display: inline-block" class="small-title">仅支持中英文和数字，字数不超过4个汉字或8个字母</p>
                </div>
              </div>
              <div class="edit_area_content" v-if="editAreaShow.show">
                <Row style="margin-bottom: 10px">
                  <Col span="3" style="font-size: 16px; margin-right: 16px">{{editAreaShow.title}}内容</Col>
                  <Col span="12">
                    <RadioGroup v-model="menuType" @on-change="changeType">
                      <Radio style="font-size: 16px" label="click">发送消息</Radio>
                      <Radio style="font-size: 16px" label="view">跳转网页</Radio>
                      <Radio style="font-size: 16px" label="miniprogram">跳转小程序</Radio>
                    </RadioGroup>
                  </Col>
                </Row>
                <!--发送消息卡片-->
                <Card v-show="menuType === 'click'">
                  <Tabs value="text">
                    <TabPane label="图文消息" name="picandtext" icon="card">
                      <!--三个button-->
                      <Row type="flex" justify="center" class="code-row-bg">
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-folder-outline" size="30"></Icon></p>
                              <p class="icon-color">从素材库选择</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="paintbrush" size="30"></Icon></p>
                              <p class="icon-color">自建图文</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="share" size="30"></Icon></p>
                              <p class="icon-color">转载文章</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane label="文字" name="text" icon="ios-paper">
                      <!--<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/0.gif">-->
                      <div class="input-area">
                        <Input type="textarea" :rows="6"></Input>
                      </div>
                      <Row style="margin-top:10px;">
                        <Col span="19">&nbsp;</Col>
                        <Col span="5" style="color: #888888;">还可以输入字</Col>
                      </Row>
                    </TabPane>
                    <TabPane label="图片" name="pic" icon="image">
                      <!--两个button-->
                      <Row type="flex" justify="center" class="code-row-bg">
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;">
                                <Icon type="ios-folder-outline" size="30"></Icon>
                              </p>
                              <p class="icon-color">从素材库选择</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="image" size="30"></Icon></p>
                              <p class="icon-color">上传图片</p>
                            </div>
                          </div>

                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane label="语音" name="voice" icon="ios-mic">
                      <!--两个button-->
                      <Row type="flex" justify="center" class="code-row-bg">
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-folder-outline" size="30"></Icon></p>
                              <p class="icon-color">从素材库选择</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-mic" size="30"></Icon></p>
                              <p class="icon-color">新建语音</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane label="视频" name="video" icon="ios-videocam">
                      <!--两个button-->
                      <Row type="flex" justify="center" class="code-row-bg">
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-folder-outline" size="30"></Icon></p>
                              <p class="icon-color">从素材库选择</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-videocam" size="30"></Icon></p>
                              <p class="icon-color">新建视频</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  </Tabs>
                </Card>
                <!--跳转网页卡片-->
                <Card v-show="menuType === 'view'">
                  <p class="small-title">订阅者点击该{{editAreaShow.title}}会跳到以下链接</p>
                  <Row style="margin-top: 1em;">
                    <Col span="3" style="margin-top: 5px;">页面地址</Col>
                    <Col span="15">
                      <Row><Input style="width: 350px;" v-model="selectedBtn.viewUrl" @on-change="disInRealtime"></Input></Row>
                      <Row><a class="delete-menu" href="javascript:void(0);">从公众号图文消息中选择</a></Row>
                    </Col>
                  </Row>
                </Card>
                <!--跳转小程序-->
                <Card v-show="menuType === 'miniprogram'">
                  <p class="small-title">订阅者点击该子菜单会跳到以下小程序</p>
                  <Row style="margin-top: 1em;" >
                    <Col span="3" style="margin-top: 5px;">小程序appID</Col>
                    <Col span="15">
                      <Row><Input style="width: 350px;" v-model="selectedBtn.appid" @on-change="disInRealtime"></Input></Row>
<!--                      <Button type="default" ghost>选择小程序</Button>-->
                    </Col>
                  </Row>
                  <Row style="margin-top: 1em;">
                    <Col span="3" style="margin-top: 5px;">小程序路径</Col>
                    <Col span="15">
                      <Row><Input style="width: 350px;" v-model="selectedBtn.miniProgramPagePath" @on-change="disInRealtime"></Input></Row>
                      <!--<Row><p class="small-title">已选择小程序 - 护瞳</p></Row>
                      <Row><Button type="default" ghost >重新选择</Button></Row>-->
                    </Col>
                  </Row>
                  <Row style="margin-top: 1em;">
                    <Col span="3" style="margin-top: 5px;">备用网页</Col>
                    <Col span="18">
                      <Row><Input style="width: 350px;" v-model="selectedBtn.miniProgramUrl" @on-change="disInRealtime"></Input></Row>
                      <Row><p class="small-title">旧版微信客户端无法支持小程序，用户点击菜单时将会打开备用网页。 </p></Row>
                    </Col>
                  </Row>
                </Card>
              </div>
              <span class="edit_area_arrow">
                <i class="edit_area_arrow_out"></i>
                <i class="edit_area_arrow_in"></i>
              </span>
            </div>
            <div style="width: 100%;text-align: center;position: relative;top: 26px;">
              <Button type="success" ghost class="orderBtn" @click="saveChange">保存并发布</Button>
              <Button type="default" ghost class="orderBtn" disabled>预览</Button>
            </div>
          </div>
        </Card>
      </TabPane>
      <TabPane label="无障碍科技" name="ACCESSIBILITY_TECHNOLOGY">
        <Card class="mainBody">
          <div class="leftPanel">
            <div class="phoneTitle"><p style="color:white;font-size: 16px;">{{publicTitle}}</p></div>
            <draggable class="list-group" tag="ul" v-model="menuList" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
              <li class="list-group-item" :class="menuSize" v-for="(item, index) in menuList" :key="item.name">
                <a href="javascript:void(0)" class="pre_menu_link" @click="selectMenu(item, index)" v-show="!editable">
                  <span class="badge">{{item.name}}</span>
                </a>
                <a href="javascript:void(0)" class="pre_menu_link" v-show="editable">
                  <span class="badge">{{item.name}}</span>
                </a>
                <div class="sub_pre_menu" v-if="selectedMenu.name === item.name" v-show="!editable">
                  <ul class="sub_pre_menu_list" v-if="item['sub_button']">
                    <li class="sub-group-item"  v-for="(element, index2) in item['sub_button']" :key="element.name">
                      <a href="javascript:void(0)" class="pre_menu_link" @click="selectSubMenu(element, index, index2)">
                        <span class="badge">{{element.name}}</span>
                      </a>
                    </li>
                    <li class="add_list" v-if="item['sub_button'].length !== 5">
                      <a href="javascript:void(0)" class="add_link" title="最多添加5个二级菜单" draggable="false" @click="addSubMenu(index)">
                        <i class="add_icon"></i>
                      </a>
                    </li>
                  </ul>
                  <ul class="sub_pre_menu_list" v-else>
                    <li class="add_list">
                      <a href="javascript:void(0)" class="add_link" title="最多添加5个二级菜单" draggable="false" @click="addSubMenu(index)">
                        <i class="add_icon"></i>
                      </a>
                    </li>
                  </ul>
                  <i class="arrow_out"></i>
                  <i class="arrow_in"></i>
                </div>
              </li>
              <li class="add_list" :class="menuSize" v-if="menuList.length !== 3" v-show="!editable">
                <a href="javascript:void(0)" class="add_link" title="最多添加3个一级菜单" draggable="false" @click="addMenu">
                  <i class="add_icon"></i>
                </a>
              </li>
            </draggable>
            <div style="width: 100%;text-align: center;position: relative; top: 570px">
              <Button type="default" ghost class="orderBtn" v-if="!editable" @click="startDrag">菜单排序</Button>
              <Button type="default" ghost @click="finishDrag" class="orderBtn" v-if="editable">完成</Button>
            </div>
          </div>
          <div class="rightPanel">
            <div class="message" v-show="messageShow.show">{{messageShow.tip}}</div>
            <div class="edit_area" v-show="!messageShow.show">
              <div class="edit_area_header">
                <div style="height: 20px">
                  <h3 style="float: left">{{editAreaShow.title}}名称</h3>
                  <a href="javascript:void(0);" style="float: right;" @click="deletePublicMenu">删除{{editAreaShow.title}}</a>
                </div>
              </div>
              <div class="edit_area_name">
                <div v-show="!editAreaShow.show">
                  <p class="small-title">已添加子菜单，仅可设置菜单名称。</p><br>
                </div>
                <label style="font-size: 16px; margin-right: 16px">{{editAreaShow.title}}名称</label>
                <div style="display: inline-grid;">
                  <Input style="width: 350px;" v-model="selectedBtn.name" @on-change="disInRealtime"></Input>
                  <p style="font: 12px gray; display: inline-block" class="small-title">仅支持中英文和数字，字数不超过4个汉字或8个字母</p>
                </div>
              </div>
              <div class="edit_area_content" v-if="editAreaShow.show">
                <Row style="margin-bottom: 10px">
                  <Col span="3" style="font-size: 16px; margin-right: 16px">{{editAreaShow.title}}内容</Col>
                  <Col span="12">
                    <RadioGroup v-model="menuType" @on-change="changeType">
                      <Radio style="font-size: 16px" label="click">发送消息</Radio>
                      <Radio style="font-size: 16px" label="view">跳转网页</Radio>
                      <Radio style="font-size: 16px" label="miniprogram">跳转小程序</Radio>
                    </RadioGroup>
                  </Col>
                </Row>
                <!--发送消息卡片-->
                <Card v-show="menuType === 'click'">
                  <Tabs value="text">
                    <TabPane label="图文消息" name="picandtext" icon="card">
                      <!--三个button-->
                      <Row type="flex" justify="center" class="code-row-bg">
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-folder-outline" size="30"></Icon></p>
                              <p class="icon-color">从素材库选择</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="paintbrush" size="30"></Icon></p>
                              <p class="icon-color">自建图文</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="share" size="30"></Icon></p>
                              <p class="icon-color">转载文章</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane label="文字" name="text" icon="ios-paper">
                      <!--<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/0.gif">-->
                      <div class="input-area">
                        <Input type="textarea" :rows="6"></Input>
                      </div>
                      <Row style="margin-top:10px;">
                        <Col span="19">&nbsp;</Col>
                        <Col span="5" style="color: #888888;">还可以输入字</Col>
                      </Row>
                    </TabPane>
                    <TabPane label="图片" name="pic" icon="image">
                      <!--两个button-->
                      <Row type="flex" justify="center" class="code-row-bg">
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;">
                                <Icon type="ios-folder-outline" size="30"></Icon>
                              </p>
                              <p class="icon-color">从素材库选择</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="image" size="30"></Icon></p>
                              <p class="icon-color">上传图片</p>
                            </div>
                          </div>

                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane label="语音" name="voice" icon="ios-mic">
                      <!--两个button-->
                      <Row type="flex" justify="center" class="code-row-bg">
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-folder-outline" size="30"></Icon></p>
                              <p class="icon-color">从素材库选择</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-mic" size="30"></Icon></p>
                              <p class="icon-color">新建语音</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane label="视频" name="video" icon="ios-videocam">
                      <!--两个button-->
                      <Row type="flex" justify="center" class="code-row-bg">
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-folder-outline" size="30"></Icon></p>
                              <p class="icon-color">从素材库选择</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-videocam" size="30"></Icon></p>
                              <p class="icon-color">新建视频</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  </Tabs>
                </Card>
                <!--跳转网页卡片-->
                <Card v-show="menuType === 'view'">
                  <p class="small-title">订阅者点击该{{editAreaShow.title}}会跳到以下链接</p>
                  <Row style="margin-top: 1em;">
                    <Col span="3" style="margin-top: 5px;">页面地址</Col>
                    <Col span="15">
                      <Row><Input style="width: 350px;" v-model="selectedBtn.viewUrl" @on-change="disInRealtime"></Input></Row>
                      <Row><a class="delete-menu" href="javascript:void(0);">从公众号图文消息中选择</a></Row>
                    </Col>
                  </Row>
                </Card>
                <!--跳转小程序-->
                <Card v-show="menuType === 'miniprogram'">
                  <p class="small-title">订阅者点击该子菜单会跳到以下小程序</p>
                  <Row style="margin-top: 1em;" >
                    <Col span="3" style="margin-top: 5px;">小程序appID</Col>
                    <Col span="15">
                      <Row><Input style="width: 350px;" v-model="selectedBtn.appid" @on-change="disInRealtime"></Input></Row>
                      <!--                      <Button type="default" ghost>选择小程序</Button>-->
                    </Col>
                  </Row>
                  <Row style="margin-top: 1em;">
                    <Col span="3" style="margin-top: 5px;">小程序路径</Col>
                    <Col span="15">
                      <Row><Input style="width: 350px;" v-model="selectedBtn.miniProgramPagePath" @on-change="disInRealtime"></Input></Row>
                      <!--<Row><p class="small-title">已选择小程序 - 护瞳</p></Row>
                      <Row><Button type="default" ghost >重新选择</Button></Row>-->
                    </Col>
                  </Row>
                  <Row style="margin-top: 1em;">
                    <Col span="3" style="margin-top: 5px;">备用网页</Col>
                    <Col span="18">
                      <Row><Input style="width: 350px;" v-model="selectedBtn.miniProgramUrl" @on-change="disInRealtime"></Input></Row>
                      <Row><p class="small-title">旧版微信客户端无法支持小程序，用户点击菜单时将会打开备用网页。 </p></Row>
                    </Col>
                  </Row>
                </Card>
              </div>
              <span class="edit_area_arrow">
                <i class="edit_area_arrow_out"></i>
                <i class="edit_area_arrow_in"></i>
              </span>
            </div>
            <div style="width: 100%;text-align: center;position: relative;top: 26px;">
              <Button type="success" ghost class="orderBtn" @click="saveChange">保存并发布</Button>
              <Button type="default" ghost class="orderBtn" disabled>预览</Button>
            </div>
          </div>
        </Card>
      </TabPane>
      <TabPane label="启明瞳" name="qmtfwh">
        <Card class="mainBody">
          <div class="leftPanel">
            <div class="phoneTitle"><p style="color:white;font-size: 16px;">{{publicTitle}}</p></div>
            <draggable class="list-group" tag="ul" v-model="menuList" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
              <li class="list-group-item" :class="menuSize" v-for="(item, index) in menuList" :key="item.name">
                <a href="javascript:void(0)" class="pre_menu_link" @click="selectMenu(item, index)" v-show="!editable">
                  <span class="badge">{{item.name}}</span>
                </a>
                <a href="javascript:void(0)" class="pre_menu_link" v-show="editable">
                  <span class="badge">{{item.name}}</span>
                </a>
                <div class="sub_pre_menu" v-if="selectedMenu.name === item.name" v-show="!editable">
                  <ul class="sub_pre_menu_list" v-if="item['sub_button']">
                    <li class="sub-group-item"  v-for="(element, index2) in item['sub_button']" :key="element.name">
                      <a href="javascript:void(0)" class="pre_menu_link" @click="selectSubMenu(element, index, index2)">
                        <span class="badge">{{element.name}}</span>
                      </a>
                    </li>
                    <li class="add_list" v-if="item['sub_button'].length !== 5">
                      <a href="javascript:void(0)" class="add_link" title="最多添加5个二级菜单" draggable="false" @click="addSubMenu(index)">
                        <i class="add_icon"></i>
                      </a>
                    </li>
                  </ul>
                  <ul class="sub_pre_menu_list" v-else>
                    <li class="add_list">
                      <a href="javascript:void(0)" class="add_link" title="最多添加5个二级菜单" draggable="false" @click="addSubMenu(index)">
                        <i class="add_icon"></i>
                      </a>
                    </li>
                  </ul>
                  <i class="arrow_out"></i>
                  <i class="arrow_in"></i>
                </div>
              </li>
              <li class="add_list" :class="menuSize" v-if="menuList.length !== 3" v-show="!editable">
                <a href="javascript:void(0)" class="add_link" title="最多添加3个一级菜单" draggable="false" @click="addMenu">
                  <i class="add_icon"></i>
                </a>
              </li>
            </draggable>
            <div style="width: 100%;text-align: center;position: relative; top: 570px">
              <Button type="default" ghost class="orderBtn" v-if="!editable" @click="startDrag">菜单排序</Button>
              <Button type="default" ghost @click="finishDrag" class="orderBtn" v-if="editable">完成</Button>
            </div>
          </div>
          <div class="rightPanel">
            <div class="message" v-show="messageShow.show">{{messageShow.tip}}</div>
            <div class="edit_area" v-show="!messageShow.show">
              <div class="edit_area_header">
                <div style="height: 20px">
                  <h3 style="float: left">{{editAreaShow.title}}名称</h3>
                  <a href="javascript:void(0);" style="float: right;" @click="deletePublicMenu">删除{{editAreaShow.title}}</a>
                </div>
              </div>
              <div class="edit_area_name">
                <div v-show="!editAreaShow.show">
                  <p class="small-title">已添加子菜单，仅可设置菜单名称。</p><br>
                </div>
                <label style="font-size: 16px; margin-right: 16px">{{editAreaShow.title}}名称</label>
                <div style="display: inline-grid;">
                  <Input style="width: 350px;" v-model="selectedBtn.name" @on-change="disInRealtime"></Input>
                  <p style="font: 12px gray; display: inline-block" class="small-title">仅支持中英文和数字，字数不超过4个汉字或8个字母</p>
                </div>
              </div>
              <div class="edit_area_content" v-if="editAreaShow.show">
                <Row style="margin-bottom: 10px">
                  <Col span="3" style="font-size: 16px; margin-right: 16px">{{editAreaShow.title}}内容</Col>
                  <Col span="12">
                    <RadioGroup v-model="menuType" @on-change="changeType">
                      <Radio style="font-size: 16px" label="click">发送消息</Radio>
                      <Radio style="font-size: 16px" label="view">跳转网页</Radio>
                      <Radio style="font-size: 16px" label="miniprogram">跳转小程序</Radio>
                    </RadioGroup>
                  </Col>
                </Row>
                <!--发送消息卡片-->
                <Card v-show="menuType === 'click'">
                  <Tabs value="text">
                    <TabPane label="图文消息" name="picandtext" icon="card">
                      <!--三个button-->
                      <Row type="flex" justify="center" class="code-row-bg">
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-folder-outline" size="30"></Icon></p>
                              <p class="icon-color">从素材库选择</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="paintbrush" size="30"></Icon></p>
                              <p class="icon-color">自建图文</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="share" size="30"></Icon></p>
                              <p class="icon-color">转载文章</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane label="文字" name="text" icon="ios-paper">
                      <!--<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/0.gif">-->
                      <div class="input-area">
                        <Input type="textarea" :rows="6"></Input>
                      </div>
                      <Row style="margin-top:10px;">
                        <Col span="19">&nbsp;</Col>
                        <Col span="5" style="color: #888888;">还可以输入字</Col>
                      </Row>
                    </TabPane>
                    <TabPane label="图片" name="pic" icon="image">
                      <!--两个button-->
                      <Row type="flex" justify="center" class="code-row-bg">
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;">
                                <Icon type="ios-folder-outline" size="30"></Icon>
                              </p>
                              <p class="icon-color">从素材库选择</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="image" size="30"></Icon></p>
                              <p class="icon-color">上传图片</p>
                            </div>
                          </div>

                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane label="语音" name="voice" icon="ios-mic">
                      <!--两个button-->
                      <Row type="flex" justify="center" class="code-row-bg">
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-folder-outline" size="30"></Icon></p>
                              <p class="icon-color">从素材库选择</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-mic" size="30"></Icon></p>
                              <p class="icon-color">新建语音</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane label="视频" name="video" icon="ios-videocam">
                      <!--两个button-->
                      <Row type="flex" justify="center" class="code-row-bg">
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-folder-outline" size="30"></Icon></p>
                              <p class="icon-color">从素材库选择</p>
                            </div>
                          </div>
                        </Col>
                        <Col span="7">
                          <div class="inner-div">
                            <div class="inner-div">
                              <p class="icon-color" style="padding-top:50px;"><Icon type="ios-videocam" size="30"></Icon></p>
                              <p class="icon-color">新建视频</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  </Tabs>
                </Card>
                <!--跳转网页卡片-->
                <Card v-show="menuType === 'view'">
                  <p class="small-title">订阅者点击该{{editAreaShow.title}}会跳到以下链接</p>
                  <Row style="margin-top: 1em;">
                    <Col span="3" style="margin-top: 5px;">页面地址</Col>
                    <Col span="15">
                      <Row><Input style="width: 350px;" v-model="selectedBtn.viewUrl" @on-change="disInRealtime"></Input></Row>
                      <Row><a class="delete-menu" href="javascript:void(0);">从公众号图文消息中选择</a></Row>
                    </Col>
                  </Row>
                </Card>
                <!--跳转小程序-->
                <Card v-show="menuType === 'miniprogram'">
                  <p class="small-title">订阅者点击该子菜单会跳到以下小程序</p>
                  <Row style="margin-top: 1em;" >
                    <Col span="3" style="margin-top: 5px;">小程序appID</Col>
                    <Col span="15">
                      <Row><Input style="width: 350px;" v-model="selectedBtn.appid" @on-change="disInRealtime"></Input></Row>
                      <!--                      <Button type="default" ghost>选择小程序</Button>-->
                    </Col>
                  </Row>
                  <Row style="margin-top: 1em;">
                    <Col span="3" style="margin-top: 5px;">小程序路径</Col>
                    <Col span="15">
                      <Row><Input style="width: 350px;" v-model="selectedBtn.miniProgramPagePath" @on-change="disInRealtime"></Input></Row>
                      <!--<Row><p class="small-title">已选择小程序 - 护瞳</p></Row>
                      <Row><Button type="default" ghost >重新选择</Button></Row>-->
                    </Col>
                  </Row>
                  <Row style="margin-top: 1em;">
                    <Col span="3" style="margin-top: 5px;">备用网页</Col>
                    <Col span="18">
                      <Row><Input style="width: 350px;" v-model="selectedBtn.miniProgramUrl" @on-change="disInRealtime"></Input></Row>
                      <Row><p class="small-title">旧版微信客户端无法支持小程序，用户点击菜单时将会打开备用网页。 </p></Row>
                    </Col>
                  </Row>
                </Card>
              </div>
              <span class="edit_area_arrow">
                <i class="edit_area_arrow_out"></i>
                <i class="edit_area_arrow_in"></i>
              </span>
            </div>
            <div style="width: 100%;text-align: center;position: relative;top: 26px;">
              <Button type="success" ghost class="orderBtn" @click="saveChange">保存并发布</Button>
              <Button type="default" ghost class="orderBtn" disabled>预览</Button>
            </div>
          </div>
        </Card>
      </TabPane>
      <div class="helpInfo" slot="extra">
        <a target="_blank" href="http://kf.qq.com/faq/120911VrYVrA150210BBJvei.html">自定义菜单使用说明
          <Icon type="ios-book-outline"></Icon>
        </a>
      </div>
    </Tabs>
    <Modal v-model="handleTips.show" title="温馨提示" @on-ok="handleConfirm">
      <Row type="flex" justify="end" class="code-row-bg">
        <Col span="3"><img src="../../../static/gantan.png" alt="" width="50px" height="50px"></Col>
        <Col span="18">
          <Row>{{handleTips.title}}</Row>
          <Row class="small-title">{{handleTips.tips}}</Row>
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
  import draggable from 'vuedraggable';
  export default {
    name: "publicSetting",
    components: {
      draggable,
    },
    data() {
      return {
        editable: false,
        isDragging: false,
        delayedDragging: false,
        menuOrder: [],
        handleTips: {
          show: false,
          tips: '',
          title: ''
        },
        menuType: 'miniprogram',
        publicMenu: {}, //公众号菜单数据
        menuList: [], //公众号一级菜单内容
        appName: 'I_Can_Help', //公众号的name值
        publicTitle: '我能帮帮忙', //显示的公众号标题
        selectedBtn: {},
        selectedMenu: {},  //选中的一级菜单信息
        selectedSubMenu: {}, //选中的二级菜单信息
        newMenu: {
          name: '新菜单',
          type: 'view',
          url: ''
        },
        newSubMenu: {
          name: '新子菜单',
          type: 'view',
          url: ''
        },
        editAreaShow: {  //控制菜单编辑内容显示
          show: false,
          title: '菜单',
        },
        messageShow: {  //控制提示信息显示
          show: true,
          tip: '点击左侧菜单进行编辑操作'
        },
        sendBtnData: {}

      };
    },
    methods:{
      tabChanged(name){
        this.appName = name;
        switch (name) {
          case 'I_Can_Help':
            this.publicTitle = '我能帮帮忙';
            break;
          case 'ACCESSIBILITY_TECHNOLOGY':
            this.publicTitle = '无障碍科技';
            break;
          case 'qmtfwh':
            this.publicTitle = '启明瞳';
            break;
          default:
            this.publicTitle = '我能帮帮忙';
            break;
        }
        this.publicMenu = {};
        this.menuList = [];
        this.$http.post('/zm/backManage/getWXPublicNumberMenu?appName='+this.appName).then(
          (res) => {
              this.publicMenu = JSON.parse(res.data.content);
              let tempList = this.publicMenu.selfmenu_info.button;
              for (let i = 0; i < tempList.length; i++){
                  if (tempList[i]['sub_button'] && tempList[i].sub_button['list'] && tempList[i].sub_button.list.length !== 0){
                      let tempArr = tempList[i].sub_button.list;
                      tempList[i].sub_button = [];
                      tempList[i].sub_button = tempArr;
                  }
              }
              this.menuList = tempList;
          },
          err => {
            this.$Message.error("请求失败：" + err.message);
          }
        );
      },
      selectMenu(item, index){
        this.messageShow.show = false;
        this.selectedMenu = item;
        this.selectedBtn = {};
        this.selectedBtn.type = 'btn';
        this.selectedBtn.name = item.name;
        this.selectedBtn.menuIndex = index;
        if (item.type){
          this.menuType = item.type;
          if (item.type === 'view'){
            this.selectedBtn.viewUrl = item.url;
          }
          if (item.type === 'miniprogram') {
            this.selectedBtn.miniProgramPagePath = item.pagepath;
            this.selectedBtn.miniProgramUrl = item.url;
            this.selectedBtn.appid = item.appid;
          }
        }
        if (item['sub_button'] && item.sub_button.length !== 0) {
          this.editAreaShow.show = false;
        } else {
          this.editAreaShow.show = true;
        }
        this.editAreaShow.title = '菜单';
      },
      selectSubMenu(item, index, index2){
        this.messageShow.show = false;
        this.selectedSubMenu = item;
        this.selectedBtn = {};
        this.selectedBtn.type = 'subBtn';
        this.selectedBtn.name = item.name;
        this.selectedBtn.menuIndex = index;
        this.selectedBtn.subMenuIndex = index2;
        if (item.type){
          this.menuType = item.type;
          if (item.type === 'view'){
            this.selectedBtn.viewUrl = item.url;
          }
          if (item.type === 'miniprogram') {
            this.selectedBtn.miniProgramPagePath = item.pagepath;
            this.selectedBtn.miniProgramUrl = item.url;
            this.selectedBtn.appid = item.appid;
          }
        }
        this.editAreaShow.show = true;
        this.editAreaShow.title = '子菜单';
      },
      addMenu(){
        let i = this.menuList.length + 1;
        let menu = {};
        menu.name = this.newMenu.name + i;
        menu.type = this.newMenu.type;
        this.menuList.push(menu);
        this.selectMenu(menu, this.menuList.length-1);
      },
      addSubMenu(index){
        if (this.menuList[index]['sub_button'] && this.menuList[index].sub_button.length !== 0) {
          let i = this.menuList[index].sub_button.length + 1;
          let subMenu = {};
          subMenu.name = this.newSubMenu.name + i;
          subMenu.type = this.newSubMenu.type;
          this.menuList[index].sub_button.push(subMenu);
          this.selectSubMenu(subMenu, index, this.menuList[index].sub_button.length-1);
        }else {
          this.handleTips.show = true;
          this.handleTips.title = '子菜单确认';
          this.handleTips.tips = '添加子菜单后，一级菜单的内容将被清除。确定添加子菜单？';
        }

      },
      changeType(type){
        //发送消息  跳转网页  跳转小程序
        this.menuType = type;
      }, //改变 菜单内容 的显示
      handleConfirm(){
        if (this.handleTips.title === '子菜单确认') {
          let index = this.selectedBtn.menuIndex;
          this.menuList[index] ={
            name: this.menuList[index].name,
            sub_button: []
          };
          let i = this.menuList[index].sub_button.length + 1;
          let subMenu = {};
          subMenu.name = this.newSubMenu.name + i;
          subMenu.type = this.newSubMenu.type;
          this.menuList[index].sub_button.push(subMenu);
          this.selectSubMenu(subMenu, index, this.menuList[index].sub_button.length-1);
          this.handleTips.show = false;
        } else if (this.handleTips.title === '删除确认') {
          if (this.selectedBtn.type === 'subBtn'){
            this.menuList[this.selectedBtn.menuIndex].sub_button.splice(this.selectedBtn.subMenuIndex, 1);
            this.messageShow.show = true;
          } else if (this.selectedBtn.type === 'btn'){
            this.menuList.splice(this.selectedBtn.menuIndex, 1);
            this.messageShow.show = true;
          }
        }
      },
      deletePublicMenu(){
        this.handleTips.show = true;
        this.handleTips.title = '删除确认';
        this.handleTips.tips = '删除后“'+this.selectedBtn.name+'”菜单下设置的内容将被删除';
      },
      disInRealtime(e){
        if (this.selectedBtn.type === 'subBtn'){
          let tempObj = this.menuList[this.selectedBtn.menuIndex].sub_button[this.selectedBtn.subMenuIndex];
          if (this.menuType === 'view'){
            tempObj = {};
            tempObj.name = this.selectedBtn.name;
            tempObj.type = this.menuType;
            tempObj.url = this.selectedBtn.viewUrl;
          } else if (this.menuType === 'miniprogram'){
            tempObj = {};
            tempObj.name = this.selectedBtn.name;
            tempObj.type = this.menuType;
            tempObj.url = this.selectedBtn.miniProgramUrl;
            tempObj.pagepath = this.selectedBtn.miniProgramPagePath;
            tempObj.appid = this.selectedBtn.appid;
          }
          this.menuList[this.selectedBtn.menuIndex].sub_button[this.selectedBtn.subMenuIndex] = tempObj;
        } else if (this.selectedBtn.type === 'btn'){
            let tempObj = this.menuList[this.selectedBtn.menuIndex];
              tempObj.name = this.selectedBtn.name;
              if (this.editAreaShow.show) {
                  if (this.menuType === 'view'){
                      tempObj = {};
                      tempObj.name = this.selectedBtn.name;
                      tempObj.type = this.menuType;
                      tempObj.url = this.selectedBtn.viewUrl;
                  } else if (this.menuType === 'miniprogram'){
                      tempObj = {};
                      tempObj.name = this.selectedBtn.name;
                      tempObj.type = this.menuType;
                      tempObj.url = this.selectedBtn.miniProgramUrl;
                      tempObj.pagepath = this.selectedBtn.miniProgramPagePath;
                      tempObj.appid = this.selectedBtn.appid;
                  }
              }
          this.menuList[this.selectedBtn.menuIndex] = tempObj;
        }
      },
      startDrag(){
        this.editable = !this.editable;
        this.messageShow.show = true;
        this.messageShow.tip = '拖拽左侧菜单进行排序操作';
      },
      finishDrag(){
        this.editable = !this.editable;
        this.messageShow.tip = '点击左侧菜单进行编辑操作';
      },
      onMove({ relatedContext, draggedContext }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return (
          (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
        );
      },
      saveChange(){
        this.sendBtnData.appName = this.appName;
        this.sendBtnData.button = this.menuList;
        console.log(this.sendBtnData);
        this.$http.post('/zm/backManage/updateWXPublicNumberMenu', this.sendBtnData).then(
          res => {
            if (res.data.content){
              if (res.data.content === '更新成功') {
                this.$Message.success(res.data.content);
              } else {
                this.$Message.error(res.data.content);
              }

            }
            if (res.data.errorMsg) {
              this.$Message.error('操作失败' + res.data.errorMsg);
            }

          },
          err => {
            this.$Message.error("请求失败：" + err.message);
          }
        );
      }
    },
    computed:{
      menuSize: function(){
        return {
          sizeOf1: this.menuList.length === 0,
          sizeOf2: this.menuList.length === 1,
          sizeOf3: this.menuList.length === 2 || this.menuList.length === 3
        };
      },
      dragOptions() {
        return {
          animation: 0,
          group: "description",
          disabled: !this.editable,
          ghostClass: "ghost"
        };
      }
    },
    watch: {
      isDragging(newValue) {
        if (newValue) {
          this.delayedDragging = true;
          return;
        }
        this.$nextTick(() => {
          this.delayedDragging = false;
        });
      }
    },
    created() {
        this.$http.post('/zm/backManage/getWXPublicNumberMenu?appName='+this.appName).then(
          (res) => {
            this.publicMenu = JSON.parse(res.data.content);
            let tempList = this.publicMenu.selfmenu_info.button;
              for (let i = 0; i < tempList.length; i++){
                  if (tempList[i]['sub_button'] && tempList[i].sub_button['list'] && tempList[i].sub_button.list.length !== 0){
                      let tempArr = tempList[i].sub_button.list;
                      tempList[i].sub_button = [];
                      tempList[i].sub_button = tempArr;
                  }
              }
            this.menuList = tempList;
          },
          err => {
            this.$Message.error("请求失败：" + err.message);
          }
        );
    }
  };
</script>

<style scoped>

  .helpInfo{
    display: inline-block;
    position: relative;
  }
  .helpInfo a{
    float: right;
    color: #9d9d9d;
    font-size: 16px;
    margin-top: 10px;
    margin-right: 20px;
  }
  .mainBody{
    height: 750px;
    width: 90%;
  }
  .leftPanel{
    background-image: url("../../../static/phone.png");
    height: 600px;
    width: 306px;
    position: relative;
    top:30px;
    left: 40px;
    display: inline-block;
    float: left;
    margin-right: 12px;
  }  /*左侧面板*/
  .phoneTitle{
    position: absolute;
    top: 30px;
    left: 115px;
  }
  .list-group {
    width: 258px;
    display: inline-block;
    height: 52px;
    position: relative;
    top: 545px;
    left: 46px;
  }
  .list-group-item {
    text-align: center;
    width: auto;
    line-height: 60px;
    cursor: move;
    list-style-type: none;
    display: list-item;
    float: left;
    position: relative;
  }
  .list-group-item i {
    cursor: pointer;
  }
  .pre_menu_link{
    border: 1px solid lightgray;
    line-height: 50px;
    background-color: #fff;
    color: black;
    display: block;
    width: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: normal;
    text-decoration: none;
  }
  .sub_pre_menu{
    bottom: 64px;
    background-color: #fafafa;
    position: absolute;
    left: 0;
    width: 100%;
    border: 1px #d0d0d0;
  }
  .sub_pre_menu_list{
    list-style-type: none;
  }
  .add_list{
    float: none;
    width: auto;
    overflow: hidden;
    text-align: center;
    position: relative;
  }
  .add_link{
    border: 1px solid lightgray;
    line-height: 50px;
    background-color: #fff;
    display: block;
    width: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: normal;
    color: #616161;
    text-decoration: none;
  }

  .rightPanel{
    position: relative;
    top:30px;
    left: 40px;
    margin-left: 12px;
    display: inline-block;
    vertical-align: top;
    float: none;
    width: 60%;
    min-width: 400px;
  }
  .message{
    display: block;
    text-align: center;
    min-height: 600px;
    padding-top: 200px;
    font-size: 18px;
  }
  .edit_area{
    display: block;
    position: relative;
    min-height: 600px;
    padding: 0 20px 5px;
    background-color: #f4f5f9;
    border: 1px solid #e7e7eb;
  }
  .edit_area_arrow{
    top: 560px;
    left: -12px;
    position: absolute;
  }
  .edit_area_arrow_out{
    display: inline-block;
    width: 0;
    height: 0;
    border-width: 12px;
    border-style: dashed;
    border-color: transparent;
    border-left-width: 0;
    border-right-color: #e7e7eb;
    border-right-style: solid;
  }
  .edit_area_arrow_in{
    display: inline-block;
    width: 0;
    height: 0;
    border-width: 12px;
    border-style: dashed;
    border-color: transparent;
    border-left-width: 0;
    border-right-style: solid;
    left: 1px;
    border-right-color: #f4f5f9;
  }
  .edit_area_header{
    padding: 9px 0;
    border-bottom: 1px solid #e7e7eb;
  }
  .edit_area_name{
    position: relative;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .edit_area_content{
    margin-top: 30px;
    margin-bottom: 10px;
  }
  .inner-div{
    width: 150px;
    height: 150px;
    margin-top: 10px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .inner-div :hover{
    background-color: #eaeaea;
  }
  .icon-color{
    color: #888888;
    text-align: center;
  }
  .small-title{
    margin-top: 1em;
    color: #8d8d8d;
  }
  .delete-menu{
    display: inline-block;
    margin-top: 1em;
  }

  .arrow_in{
    bottom: -5px;
    display: inline-block;
    width: 0;
    height: 0;
    border-width: 6px;
    border-style: dashed;
    border-color: transparent;
    border-bottom-width: 0;
    border-top-color: #fafafa;
    border-top-style: solid;
    position: absolute;
    left: 50%;
    margin-left: -6px;
  }
  .arrow_out{
    bottom: -6px;
    display: inline-block;
    width: 0;
    height: 0;
    border-width: 6px;
    border-style: dashed;
    border-color: transparent;
    border-bottom-width: 0;
    border-top-color: #d0d0d0;
    border-top-style: solid;
    position: absolute;
    left: 50%;
    margin-left: -6px;
  }
  .add_icon{
    background: url(../../assets/images/add.png) 0 0 no-repeat;
    width: 14px;
    height: 14px;
    vertical-align: middle;
    display: inline-block;
    margin-top: -2px;
  }
  .sizeOf1{
    width: 100%;
  }
  .sizeOf2{
    width: 50%;
  }
  .sizeOf3{
    width: 33.33%;
  }
</style>



// WEBPACK FOOTER //
// publicSetting.vue?b592f3e6